var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ecX2xIJB3Sb1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 556",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0-.000001)",
    clipPath: "url(#ecX2xIJB3Sb10)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "ecX2xIJB3Sb4",
    d: "M156.467,96.3008v0c0,14.3932,11.668,26.0802,26.061,26.0802v0c14.393,0,26.06-11.668,26.06-26.0607v-43.671c0-19.144,13.608-35.5851,32.415-39.1633v0c3.984-.758,8.075-.7618,12.06-.0111l2.91.548c17.335,3.2653,29.892,18.4074,29.892,36.0477v1.9546",
    fill: "none",
    stroke: "#9dc6c6",
    strokeWidth: 25,
    strokeDashoffset: 248.536908,
    strokeDasharray: 248.536908
  }), /*#__PURE__*/React.createElement("path", {
    id: "ecX2xIJB3Sb5",
    d: "M8.6176,218.907c.071193,7.2858.23731,24.286.23731,24.286.09069,9.282,7.60939,16.775,16.89109,16.834l97.392.619c9.347.059,16.892,7.653,16.892,16.999v22.068",
    fill: "none",
    stroke: "#9dc6c6",
    strokeWidth: 16,
    strokeDashoffset: 196.781159,
    strokeDasharray: 196.781159
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.959,499.699l46.608,44.203l45.004-46.264",
    fill: "none",
    stroke: "#002a2a",
    strokeWidth: 17,
    strokeDashoffset: 128.77796,
    strokeDasharray: 128.77796
  }), /*#__PURE__*/React.createElement("path", {
    id: "ecX2xIJB3Sb7",
    d: "M215.627,385.529v10.794c0,0,5.354,13.221,5.354,13.221l37.846,39.061-37.719,38.192c-3.512,3.557-5.481,8.353-5.481,13.351v11.404",
    transform: "matrix(-1 0 0 1 535.847327 0)",
    fill: "none",
    stroke: "#002a2a",
    strokeWidth: 25,
    strokeDashoffset: 159.474007,
    strokeDasharray: 159.474007
  }), /*#__PURE__*/React.createElement("path", {
    id: "ecX2xIJB3Sb8",
    d: "M215.627,385.529c0,0-.619156,7.615544,0,10.794.818195,4.200235,0,6.781246,5.354,13.221l37.846,39.061-37.719,38.192c-3.512,3.557-5.481,8.353-5.481,13.351v11.404",
    fill: "none",
    stroke: "#002a2a",
    strokeWidth: 25,
    strokeDashoffset: 159.474007,
    strokeDasharray: 159.474007
  }), /*#__PURE__*/React.createElement("path", {
    id: "ecX2xIJB3Sb9",
    d: "M248.685,447.572h32.986",
    fill: "none",
    stroke: "#002a2a",
    strokeWidth: 25,
    strokeDashoffset: 32.986,
    strokeDasharray: 32.986
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ecX2xIJB3Sb10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1145,
    height: 556,
    rx: 0,
    ry: 0,
    transform: "translate(.893799 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroLeft);
export default __webpack_public_path__ + "static/media/hero-left.db1027f06946c86c7e9f07f7d72e9e7f.svg";
export { ForwardRef as ReactComponent };